import React from 'react';
import { List } from "@mui/material";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Logo from "../../../images/logo/ontrack.png";
import CategoryHeader from './CategoryHeader';
import Submenu from './Submenu';
import NavigationItem from './NavigationItem';

const DrawerContent = ({ 
  mobileOpen, 
  setMobileOpen, 
  sidebarCategories, 
  expandedCategories, 
  selectedItem, 
  location, 
  helpSupportList, 
  handleCategoryClick, 
  handleNavigation,
  userType
}) => (
  <div className="flex flex-col h-full bg-white">
    <div className="md:hidden flex items-center justify-between py-2 px-3 border-b border-gray-300">
      <div className="flex-1">
        <a href="/" className="cursor-pointer hover:opacity-80 transition-opacity">
          <img 
            src={Logo} 
            alt="Logo" 
            className="w-24 h-auto max-w-full" 
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.style.display = "none"; 
            }} 
          />
        </a>
      </div>
      <IconButton 
        onClick={() => setMobileOpen(false)} 
        sx={{ 
          color: "black", 
          width: 32,
          height: 32,
          marginRight: 0,
          padding: 0
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </div>
    <div className="hidden md:block">
      <div className="flex flex-col items-center border-b border-gray-300">
        <a href="/" className="cursor-pointer hover:opacity-80 transition-opacity">
          <img 
            src={Logo} 
            alt="Logo" 
            className="h-20  w-full" 
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.style.display = "none"; 
            }} 
          />
        </a>
      </div>
    </div>
    <div className="flex-1 overflow-y-auto">
      <div className="px-3 py-2">
        <List className="space-y-0">
          { Array.isArray(sidebarCategories) && sidebarCategories.map((category) => {
            const isCategoryFormat = category.items && Array.isArray(category.items);
            
            if (isCategoryFormat) {
              return category && category.name ? (
                <React.Fragment key={category.name}>
                  <CategoryHeader 
                    category={category}
                    isExpanded={expandedCategories && expandedCategories.has ? expandedCategories.has(category.name) : false}
                    onToggle={() => handleCategoryClick(category)}
                    selectedItem={selectedItem}
                  />
                  {expandedCategories && expandedCategories.has && expandedCategories.has(category.name) && category.items && category.items.length > 1 && (
                    <Submenu items={category.items} location={location} onNavigation={handleNavigation} />
                  )}
                </React.Fragment>
              ) : null;
            } else {
              return category && category.name ? (
                <NavigationItem 
                  key={category.name} 
                  item={category} 
                  selectedItem={selectedItem} 
                  onNavigation={handleNavigation}
                  userType={userType}
                />
              ) : null;
            }
          })}
        </List>
        
        {userType === "user" && (
          <div className="mt-6">
            <h3 className="text-sm font-bold text-blue-800 mb-3 px-3">Help & Support</h3>
            <List className="space-y-0">
              {helpSupportList && Array.isArray(helpSupportList) && helpSupportList.map((item) => (
                item && item.name ? (
                  <NavigationItem key={item.name} item={item} selectedItem={selectedItem} onNavigation={handleNavigation} userType={userType} />
                ) : null
              ))}
            </List>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default DrawerContent; 